import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-pickerltyp-list-view',
  imports: [],
  templateUrl: './pickerltyp.list-view.html',
  styleUrls: ['./pickerltyp.list-view.css'],
})
export class PickerltypListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
